import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { MatSnackBar, MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';
import { Permissions } from '../../common/entities/Permissions';
import { RestResponse } from '../entities/rest.response.model';
import API from '../../common/services/api.config.json';
import { ApiService } from './api.service';
import { map } from 'rxjs/operators';
import Utils from 'app/Utils';

@Injectable()

export class SharedService {

    Permissions: Permissions = new Permissions();

    CurrentEmployeeId: string;
    EmployeeCompany: string;
    LoggedUser: any;
    private nevil = [];
    treeMedico = [];
    private subject = new Subject<any>();
    taskArray: Array<any> = [];
    treeMedicoAll = [];

    selectionTabList: any[] = [];
    selectedSelectionTabId = 2;

    constructor(public snackBar: MatSnackBar, public apiService: ApiService) {
    }

    sendCalanderData(taskArray: Array<any>): void {
        this.subject.next({ text: taskArray });
    }

    getCalanderData(): Observable<any> {
        return this.subject.asObservable();
    }

    getCurrentEmployeeName(): string {
        return localStorage.getItem('CurrentEmployeeName');
    }

    getCurrentUser(): any {
        let currentUser: any = JSON.parse(Utils.decrypt(localStorage.getItem('currentUser'))) ;
        return currentUser;
    }

    setCurrentEmployeeName(name: string): void {
        localStorage.setItem('CurrentEmployeeName', name);
    }

    setNevil(nevil: any): void {
        this.nevil = nevil;
        localStorage.setItem('nevil', JSON.stringify(this.nevil));
    }

    getPruebasList(): Observable<RestResponse>{
        const url = `${API.Actuaciones.pruebaList}`;
        return this.apiService.get(url);
    }

    getEspecialidadList(): Observable<RestResponse>{
        const url = `${API.Actuaciones.especialistaList}`;
        return this.apiService.get(url);
    }

    getNevil(): any {
        if (this.nevil.length > 0) {
            return this.nevil;
        } else {
            const itemString = localStorage.getItem('nevil');
            return JSON.parse(itemString);
        }
    }
    public setDataForSelectionTabList(): void {
        const localPermits = Utils.decrypt(localStorage.getItem('permissionIds'));
        const permissions: Array<string> = localPermits ? localPermits.split(',') : [];
        this.selectionTabList = [
            { id: 1, isPermit: permissions.includes('201'), viewValue: 'Trabajadores' },
            { id: 2, isPermit: permissions.includes('202'), viewValue: 'Bajas' },
            { id: 3, isPermit: permissions.includes('203'), viewValue: 'Actuaciones' },
            { id: 5, isPermit: permissions.includes('204'), viewValue: 'Tareas' },
        ];
    }

    getCurrentUserPermissions(): Array<string> {
        return Utils.decrypt(localStorage.getItem('permissionIds')).split(',');
    }

    setCurrentUserPermissions(): void {
        this.Permissions=new Permissions();
        const permissions: Array<string> = Utils.decrypt(localStorage.getItem('permissionIds')).split(',');
        permissions.forEach(permissionId => {
            if ('undefined' !== typeof (this.Permissions['HasPermisos' + permissionId])) {
                this.Permissions['HasPermisos' + permissionId] = true;
            }
        });
    }

    public ShowSnackBar(message: string, action: string = 'okay', duration: number = 2000): MatSnackBarRef<SimpleSnackBar> {
        return this.snackBar.open(message, action, {
            duration: duration
        });
    }

    public isMedicoUser(): boolean {
        let isMedico = false;
        const currentUser = JSON.parse(Utils.decrypt(localStorage.getItem('currentUser'))) ;
        if (currentUser !== null && currentUser.medicoId !== null) {
            isMedico = true;
        }
        return isMedico;
    }

    GetUsarioList(): Observable<RestResponse> {
        const url = `${API.Usuario.getUsuarioList}`;
        return this.apiService.get(url);
    }

    GetUsarioDropdown(): Observable<RestResponse> {
        return this.GetUsarioList()
            .pipe(map(resp => {
                return resp.result.map(element => {
                    return { value: element.value, viewValue: element.viewValue };
                });
            }));
    }

    GetUsarioListForAdministratoContacto(): Observable<RestResponse> {
        const url = `${API.Usuario.GetCantacoActiveUsers}`;
        return this.apiService.get(url);
    }

    GetUsarioDropdownForAdministratoContacto(): Observable<{ value: any; viewValue: any; }[]> {
        return this.GetUsarioListForAdministratoContacto()
            .pipe(map(resp => {
                return resp.result.map((element: { value: any; viewValue: any; }) => {
                    return { value: element.value, viewValue: element.viewValue };
                });
            }));
    }

    public GetCurrentEmployeeData(): any {
        const currentEmployee = localStorage.getItem('EmplooyeeData');
        if (currentEmployee.charAt(0) === '[') {
            return JSON.parse(currentEmployee[0]);
        }
        if (currentEmployee.charAt(0) === '{') {
            return JSON.parse(currentEmployee);
        }
    }
}

